import ApiCommonStore from "@/store/common/api/ApiCommonStore";
import ApiMethodStore from "@/store/common/api/ApiMethodStore";

export default {
    modules: {
        ApiCommonStore,
        ApiMethodStore
    }
}